import { useEffect, useRef } from "react";
import "./Time.scss";

const Time = () => {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current; // Capture current ref value
    const formatter = new Intl.DateTimeFormat("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
    });

    const updateTime = () => {
      if (el) {
        el.textContent = formatter.format(new Date());
      }
    };

    // Update immediately
    updateTime();

    // Calculate delay until next minute boundary
    const now = new Date();
    const msUntilNextMinute = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();

    // Sync to top of minute, then update every minute
    const timeout = setTimeout(() => {
      updateTime();
      const interval = setInterval(updateTime, 60000);
      el._interval = interval;
    }, msUntilNextMinute);

    return () => {
      clearTimeout(timeout);
      if (el?._interval) clearInterval(el._interval);
    };
  }, []);

  return <span ref={ref}></span>;
};

export default Time;
